module.exports = __webpack_public_path__ + "static/img/160.70046376.png";